const API_BASE_URL = process.env.API_BASE_URL.replace(/\/$/, '');

export default API_BASE_URL;
